import {connect} from "react-redux";
import Product from "../../Components/Product/Product";
import {bindActionCreators} from "redux";
import * as cartAction from '../../Redux/actions/carts'

const mapStateToProps = state => ({
    totalPrice:0
})
const mapDispatchToState = dispatch => ({
        ...bindActionCreators(cartAction,dispatch)
})

export default connect(mapStateToProps,mapDispatchToState)(Product)